<template>
    <div class="background">
        <div>
            <el-row>
                <el-col :span="14" :offset="5">
                    <Top/>
                </el-col>
            </el-row>
            <el-row class="row-main">
                <el-col :span="3" :offset="5" class="col-main">
                    <div class="div-main">
                        <Aside/>
                    </div>
                </el-col>
                <el-col :span="11" class="col-main">
                    <div class="div-main">
                        <h3>{{ title }}</h3>
                        <div class="pdf-container" :key="pdfKey">
                            <object
                                :data="pdfUrl + '#toolbar=0&view=FitH&zoom=100'"
                                type="application/pdf"
                                class="pdf-viewer"
                            >
                                <embed
                                    :src="pdfUrl + '#toolbar=0&view=FitH&zoom=100'"
                                    type="application/pdf"
                                    class="pdf-viewer"
                                />
                            </object>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="14" :offset="5">
                    <Footer/>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import Top from './Top';
import Aside from './Aside';
import Footer from './Footer';
export default {
    name : 'LicensePage',
    components: {
        'Top' : Top,
        'Aside' : Aside,
        'Footer' : Footer
    },
    data() {
        return {
            title: '',
            pdfUrl: '',
            pdfKey: 0
        }
    },
    watch: {
        '$route' (to) {
            this.updateContent(to.name);
        }
    },
    mounted() {
        this.updateContent(this.$route.name);
    },
    methods: {
        updateContent(routeName) {
            this.pdfKey++;
            if (routeName === 'License') {
                this.title = '药品经营许可证';
                this.pdfUrl = '/static/pdf/江西聚美医药连锁药品经营许可证.pdf';
            } else if (routeName === 'Record') {
                this.title = '互联网药品信息服务备案凭证';
                this.pdfUrl = '/static/pdf/互联网药品信息服务备案凭证.pdf';
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.background{
    height: 100%;
}
.background>div{
    background-color:  rgba(255, 255, 255, 0.5);
    height: 100%;
}
.row-main{
    height: 80%;
    margin: 10px auto;
}
.col-main,.div-main{
    height: 100%;
}
.div-main{
    padding: 8px;
    background-color:  rgba(255, 255, 255, 0.9);
    border-radius: 4px;
}
.div-main h3 {
    margin: 0 0 10px 0;
    padding: 0;
}
.pdf-container {
    width: 100%;
    height: calc(100% - 40px);
    background: #fff;
}
.pdf-viewer {
    width: 95%;
    height: 85%;
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/LicensePage.vue